
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Où est-il utilisé?`}</em></p>
    <p>{`Il a été approuvé à Bahrein, au Brésil, en Nouvelle-Zélande, au Canada, aux
Etats-Unis et en Arabie Saoudite.
`}<a parentName="p" {...{
        "href": "https://www.who.int/fr/news-room/feature-stories/detail/who-can-take-the-pfizer-biontech-covid-19--vaccine"
      }}>{`Son utilisation d’urgence a été validée par l'OMS`}</a>{`,
par de nombreux pays dont la Grande-Bretagne, ou encore par l'Europe.`}</p>
    <p>{`Le 7 octobre 2021, Pfizer a demandé aux autorités sanitaires américaines
d'autoriser en urgence l'utilisation pour les 5-11 ans. Pour cette classe d'âge,
le dosage a été abaissé.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;